import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function SectionLayout({ title, description, contents, mt }) {
  return (
    <MKBox component="section" my={6} mt={mt}>
      <Container>
        <Grid
          container
          item
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKTypography variant="h2" fontWeight="bold" mb={1}>
            {title}
          </MKTypography>
          <MKTypography variant="body1" color="text">
            {description}
          </MKTypography>
        </Grid>
        {contents}
      </Container>
    </MKBox>
  );
}

SectionLayout.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  contents: PropTypes.node,
  mt: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
};

export default SectionLayout;
